var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.matched),function(match){return _c('span',{key:match.name,staticClass:"crumb"},[_c('router-link',{attrs:{"to":match}},[_c('Locale',{attrs:{"path":`routes.${match.name}`}})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }